import React from 'react'
import PropTypes from 'prop-types'

function StepNextIcon({ height, width, fill }) {
  return (
    <svg fill={fill} height={height} width={width} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" version="1.1" x="0px" y="0px"><g stroke="none" stroke-width="1" fillRule="evenodd"><g fill={fill} fillRule="nonzero"><path d="M16.2424621,12.7424621 L10.2424621,18.7424621 C9.83241161,19.1525126 9.16758839,19.1525126 8.75753788,18.7424621 C8.34748737,18.3324116 8.34748737,17.6675884 8.75753788,17.2575379 L14.0150758,12 L8.75753788,6.74246212 C8.34748737,6.33241161 8.34748737,5.66758839 8.75753788,5.25753788 C9.16758839,4.84748737 9.83241161,4.84748737 10.2424621,5.25753788 L16.2424621,11.2575379 C16.6525126,11.6675884 16.6525126,12.3324116 16.2424621,12.7424621 L16.2424621,12.7424621 Z"></path></g></g></svg>
  )
}

StepNextIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  fill: PropTypes.string,
}

StepNextIcon.defaultProps = {
  width: '35px',
  height: '35px',
  fill: '#000000',
}

export default StepNextIcon